const config = {
    theme: 'jade',
    version: "1.0.1",
    autoHideDuration: 6000
};

export default config;